import React from 'react'
import CustomLinkComponent from '@atoms/CustomLink/CustomLinkComponent'
import Icons from '@atoms/Icons/Icons'
import * as S from './SocialMediaElements.styles'

type SocialMediaItem = {
  iconName: string
  link: string
}

type SocialMediaElementsProps = {
  socialMediaItems: Array<SocialMediaItem>
}

const SocialMediaElements = ({
  socialMediaItems
}: SocialMediaElementsProps): React.ReactNode => (
  <div className={S.SocialMediaWrapper}>
    {socialMediaItems &&
      socialMediaItems.length > 0 &&
      socialMediaItems.map(
        (
          { iconName, link }: SocialMediaItem,
          index: number
        ): React.ReactNode => (
          <CustomLinkComponent
            key={`socialMedia${index}_${iconName}`}
            href={link}
            className={S.SocialMediaIcons}
            colorScheme='whiteAlpha'
            uppercase={false}
            isExternalLink
            openInNewTab
            title={iconName}
            rel='nofollow'
          >
            <div className={S.SocialMediaIconsWrapper}>
              <Icons iconName={iconName} size='3xl' />
            </div>
          </CustomLinkComponent>
        )
      )}
  </div>
)

export default SocialMediaElements
